export const DEFAULT_SELLER_SERVICES_PAGE = {
  "hero_title": "Szolgáltatások eladóknak",
  "hero_lead": "Az AutoPark nem csak hirdetési felület: kiegészítőkkel profibb megjelenés, több megtekintés és kevesebb adminisztráció. Az alábbi funkciókat kreditekből kapcsolhatod be autónként — amit nem használsz, azért nem fizetsz.",
  "cta_primary_label": "Új hirdetés",
  "cta_primary_path": "/fiok/uj-hirdetes",
  "cta_secondary_label": "Kreditek és árak",
  "cta_secondary_path": "/kreditek",
  "sections": [
    {
      "id": "listing_basics",
      "title": "Hirdetés feladása és fenntartás",
      "tagline": "Minden aktív autó napi kreditet használ — átlátható, kiszámítható modell.",
      "body": "Új autó feladásakor egyszeri díj kerül levonásra. Amíg a hirdetés él (és van elég kredited), naponta automatikusan lefut a fenntartási díj.\n\n• A hirdetés a fiókodban szerkeszthető — képek, ár, leírás, felszereltség\n• Admin jóváhagyás után jelenik meg a nyilvános készletben\n• Ha elfogy a kredit, a hirdetés szünetelhet — /kreditek oldalon tölthetsz",
      "addon_key": "",
      "billing": "base",
      "published": true,
      "sort_order": 0
    },
    {
      "id": "viewer_360",
      "title": "360° körbeforgatás",
      "tagline": "Egy körbejáró videó — a vevő a képen húzva forgathatja az autót.",
      "body": "Egyszeri kiegészítő autónként. Bekapcsolod a hirdetésnél, majd az app beépített kamerájával vízszintesen végigsétálsz az autó körül (kb. egy teljes kör, ~25 mp). A rendszer stabilizálja a felvételt, és sima, húzható körbenézést készít.\n\n• Vevői élmény: ujjal vagy egérrel balra–jobbra húzva körbenézés — nem statikus fotó\n• „360°” jelvény a készletkártyán; a listán rövid előnézet is\n• Felvétel után minőség-visszajelzés — szükség esetén újra veheted\n• Csak az AutoPark felületén (nincs külső videófeltöltés)\n• Egyszeri kredit — a hirdetés ideje alatt aktív marad",
      "addon_key": "viewer_360",
      "billing": "one_time",
      "published": true,
      "sort_order": 10
    },
    {
      "id": "ai_photo_bg",
      "title": "AI háttércsere",
      "tagline": "Beton stúdió háttér minden galéria képen — külső és belső fotókon is.",
      "body": "Egyszeri kiegészítő autónként. Az AI a galéria fotóid mögé egységes, prémium beton stúdió jelenetet tesz (sötétszürke fal, világos padló, lágy fény) — a karosszéria, belső és szögek maradnak. Az eredeti képek megőrződnek: összehasonlítás, újrafuttatás és visszaállítás a fiókban.\n\n• Külső fotó: autó a stúdióban, természetes árnyékokkal\n• Belső fotó: ülések, műszerfal marad; az ablakon át is ugyanaz a stúdió látszik (nem utca, fa, parkoló)\n• Bekapcsoláskor vagy később a hirdetés szerkesztésében fut le a galériára\n• Legjobb eredmény: éles kép, jól látható autó, egyszerű eredeti háttér\n• Egyszeri kredit — a hirdetés ideje alatt újrafuttatható",
      "addon_key": "ai_photo_bg",
      "billing": "one_time",
      "published": true,
      "sort_order": 20
    },
    {
      "id": "ai_customer_support",
      "title": "AI ügyfélszolgálat",
      "tagline": "Azonnali válaszok érdeklődőknek — te bármikor átveheted a beszélgetést.",
      "body": "Ha valaki üzenetet küld a hirdetésedre, az AI alapinformációkkal válaszol (márka, modell, ár, felszereltség).\n\n• 24/7 reagálás — nem kell folyamatosan online lenned\n• Te továbbra is írhatsz és hívhatsz bármikor\n• Egyszeri aktiválás autónként",
      "addon_key": "ai_customer_support",
      "billing": "one_time",
      "published": true,
      "sort_order": 30
    },
    {
      "id": "list_boost",
      "title": "Kiemelés a listában",
      "tagline": "Pulzáló kék keret és AI címkék — a keresési sorrend nem változik.",
      "body": "Vizuálisan kiemeljük a hirdetésed a készletben: pulzáló kék keret veszi körül a kártyát. A fotó alján legfeljebb 3 rövid címke fut végig (futószalag) — az AI a hirdetés adataiból választ (km, felszereltség, fogyasztás stb.); csak valós információ alapján. Ha az AI nem elérhető, szabályalapú címkék jelennek meg.\n\n• Nincs külön „Kiemelt” jelvény — a kék keret és a címkék jelzik a kiemelést\n• 7 napig érvényes (30 kredit / hét); lejárat után újra aktiválható\n• Hirdetés mentésekor a címkék automatikusan frissülnek\n• A lista sorrendje és az „Ajánlott” rendezés helye nem változik — ehhez a TOP kiegészítő kell\n• Kombinálható a Kiemelt rangsorolással (TOP jelvény + előrébb sorolás)",
      "addon_key": "list_boost",
      "billing": "weekly",
      "published": true,
      "sort_order": 40
    },
    {
      "id": "priority_ranking",
      "title": "Kiemelt rangsorolás (TOP)",
      "tagline": "Elöl a találati listában — arany TOP jelvény a kártyán.",
      "body": "A keresési találatok és az „Ajánlott (kiemeltek elöl)” rendezés tetején jelenik meg a hirdetésed — ez rangsorbeli előny, nem csak vizuális keret.\n\n• „TOP” jelvény a kártyán (a sima listakiemelés kék kerete ettől külön)\n• 7 napig érvényes (50 kredit / hét); lejárat után újra aktiválható\n• A sima „Kiemelés a listában” kiegészítővel kombinálható",
      "addon_key": "priority_ranking",
      "billing": "weekly",
      "published": true,
      "sort_order": 50
    },
    {
      "id": "facebook_crosspost",
      "title": "Facebook Marketplace és csoportok",
      "tagline": "Manuális megosztás — csapatunk posztol a hirdetéseddel.",
      "body": "Egyszeri szolgáltatás: kérésre a csapatunk közzéteszi az autódat a Facebook Marketplace-en és releváns magyar autó-eladó Facebook csoportokban.\n\n• A hirdetés linkje és fotói alapján készítjük a posztot\n• Ismételhető — új kampány vagy frissítés esetén újra kérheted\n• Nem helyettesíti a Meta fizetős hirdetést — ez organikus megosztás",
      "addon_key": "facebook_crosspost",
      "billing": "one_time",
      "published": true,
      "sort_order": 55
    },
    {
      "id": "meta_ads",
      "title": "Meta hirdetés",
      "tagline": "Kampányindítási kérés — csapatunk felveszi veled a kapcsolatot.",
      "body": "Heti kiegészítő: kérést küldünk Meta (Facebook/Instagram) hirdetés indítására.\n\n• A csapat egyeztet veled célokat és költségkeretet\n• A Meta hirdetési költség külön — ez a kredit a szolgáltatás kérése\n• Egy autó vagy teljes készlet promotálása",
      "addon_key": "meta_ads",
      "billing": "weekly",
      "published": true,
      "sort_order": 60
    },
    {
      "id": "detailed_stats",
      "title": "Részletes statisztika",
      "tagline": "Napi megtekintés és érdeklődés — döntéstámogatás az árazáshoz.",
      "body": "Bekapcsolás után napi szintű grafikonokat látsz a hirdetésedről.\n\n• Megtekintések és érdeklődések idővonala\n• Ki/bekapcsolható a fiókban — extra napi kredit, amíg aktív\n• Segít eldönteni: érdemes-e árat módosítani vagy kiemelni",
      "addon_key": "detailed_stats",
      "billing": "daily_extra",
      "published": true,
      "sort_order": 70
    }
  ]
} ;
